export const WHAT_TO_BRING = [
  "A list of all the tablets you take (with the doses) — including anything from the chemist",
  "Any home blood-pressure readings you’ve done recently",
  "Any letters, scans or blood-test results you already have",
  "Photo ID",
  "A note of any heart problems in your family",
  "Anything you want to ask — write it down so you don’t forget",
];
